module.exports = __webpack_public_path__ + "media/images/ac_templates/201/mavls-a2bc0b179cd4e6eacccf81a8d3348281.jpg";